/* eslint-disable import/no-anonymous-default-export */

// Configuração do host da API
const host = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export default host;


